import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OpdataCalc } from 'src/app/models/opdataCalc.model';
import { Stage } from 'src/app/models/role.model';
import { Train } from 'src/app/models/train.model';
import { OpdataService } from 'src/app/services/opdata/opdata.service';
import { TrainService } from 'src/app/services/trains/trains.service';
import { PlotlyService } from '../plotly.service';
import { Warrantycondition } from 'src/app/models/warrantycondition.model';
import { warrantyconditionService } from 'src/app/services/warrantyconditions/warrantycondition.service';
import { RawCalcTrainDataViewModel } from 'src/app/models/OpRawCalc.model';
import { ToastrService } from 'ngx-toastr';
import { PlantsService } from 'src/app/services/plants/plants.service';

@Component({
  selector: 'app-warranties-graph',
  templateUrl: './warranties-graph.component.html',
  styleUrls: ['./warranties-graph.component.scss']
})
export class WarrantiesGraphComponent implements OnInit {
  public WindowRef : Window;
  NewWidth: any;
  opCalData: RawCalcTrainDataViewModel[] = [];
  warrantyList: Warrantycondition[] = [];
  warrantyId: any = 0;
  selectedStage: any = 1;
  plantName: string = "";
  trainDetails: Train = new Train();
  trainId: string = "";
  plantId: string = "";
  graphName: string = "";
  graphName2: string = "";
  graphName3: string = "";

  public stage: Array<Stage> = [
    { Id: 1, Name: '1' },
    { Id: 2, Name: '2' },
    { Id: 3, Name: '3' },
  ];

  public stageTotal: Array<Stage> = [
    { Id: 1, Name: 'Total' },
  ];

  /* constructor(
    private toastr: ToastrService,
    private warrantyconditionService: warrantyconditionService,
    private plot: PlotlyService,
    private trainService: TrainService,
    private route: ActivatedRoute,
    private opdataService: OpdataService
  ) {
    this.route.queryParams.subscribe(params => {
      this.trainId = atob(params['trainId']!);
      this.plantId = atob(params['plantId']!);
      this.plantName = atob(params["plantName"]!);
      this.warrantyId = params["warrantyId"];
      if (this.warrantyId) {
        this.warrantyId = atob(params["warrantyId"]!);
      }
      console.log("Constructor - warrantyId:", this.warrantyId);
    });
  } */

   constructor(
    private toastr: ToastrService,
    private warrantyconditionService: warrantyconditionService,
    private plot: PlotlyService,
    private trainService: TrainService,
    private route: ActivatedRoute,
    private router: Router, // Add Router injection
    private opdataService: OpdataService,
    private plantService: PlantsService
  ) {
    // Get data from route state instead of query params
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state || history.state;
   
    if (state && state.trainId) {
      this.trainId = state.trainId;
      this.plantId = state.plantId;
      this.plantName = state.plantName;
      this.warrantyId = state.warrantyId || 0;
     
      console.log("Constructor - State received:", {
        trainId: this.trainId,
        plantId: this.plantId,
        plantName: this.plantName,
        warrantyId: this.warrantyId
      });
    } else {
     
      this.route.queryParams.subscribe(params => {
        if (params['trainId']) {
          this.trainId = atob(params['trainId']!);
          this.plantId = atob(params['plantId']!);
          this.plantName = atob(params["plantName"]!);
          this.warrantyId = params["warrantyId"] ? atob(params["warrantyId"]!) : 0;
         
          console.log("Constructor - Query params (fallback)");
        } else {
          // No data available - handle error
          this.toastr.error('Missing navigation data', 'Error');
          console.error("No state or query params found!");
        }
      });
    }
  }
 
  
    ngOnInit(): void {
    this.WindowRef = window;
    console.log(this.WindowRef.innerWidth);
    this.NewWidth = 1500;
    if (this.WindowRef.innerWidth > 1500) {
      this.NewWidth = this.WindowRef.innerWidth;
    }
    //this.getTrainById();
    //this.getWarantiesByTrainId();

  if (this.plantId) {
    this.plantService.setSelectedPlant(Number(this.plantId));
  }

  if (this.trainId) {
    this.plantService.setSelectedTrain(Number(this.trainId));
  }

  this.loadData();

  // If user changes breadcrumb train later
  this.plantService.selectedTrain$.subscribe(id => {

    if (id) {

      this.trainId = id.toString();

      this.loadData();
    }

  });
  
  }

  loadData() {

  this.getTrainById();

  this.getWarantiesByTrainId();

}

  WarentyIdchange(e){
    console.log( e.target.value);
    console.log( this.warrantyList);

    this.warrantyId = e.target.value;
  }

  onOptionSelected() {
    let stageStr = this.trainDetails.Stages.toString();
    this.getCalcData(stageStr);
  }

  getTrainById() {
    console.log("getTrainById - trainId:", this.trainId);
    this.trainService.getTrainById(this.trainId).subscribe({
      next: (response) => {
        this.trainDetails = response;
        if (this.warrantyId > 0) {
          this.getCalcData(1);
        }
      },
    });
  }

  showGraph() {
    console.log("showGraph - warrantyId:", this.warrantyId);
    if (this.warrantyId == 0) {
      this.toastr.error('Select Warranty Condition', 'Information');
      return;
    }
    if (this.selectedStage == 0) {
      this.toastr.error('Select Stage', 'Information');
      return;
    }
    this.getCalcData(this.selectedStage);
  }

  getWarantiesByTrainId() {
    console.log("getWarantiesByTrainId - trainId:", this.trainId);
    this.warrantyconditionService.getwarrantiesByTrainId(this.trainId).subscribe({
      next: (warrantycondition) => {
        this.warrantyList = warrantycondition;
        console.log(this.warrantyList);
      },
      error: (response) => {
        console.log(response);
      },
    });
  }

  getCalcData(stageStr) {
    console.log("getCalcData - warrantyId:", this.warrantyId, "stageStr:", stageStr);
    let selectedwarranty = this.warrantyList.filter(x => x.Id == this.warrantyId)[0];
    this.opdataService.getCalcOpdataByTrainIdForWarranty(this.trainId, this.warrantyId, stageStr).subscribe({
      next: (response) => {
        this.opCalData = response;
        let x: Date[] = [];
        let y: number[] = [];
        this.opCalData.forEach(element => {
          x.push(new Date(element.Datetime));
          if (selectedwarranty.Type == 1) {
            if (stageStr == "1") {
              y.push(element.S1PermTds);
            } else if (stageStr == "2") {
              y.push(element.S2PermTds);
            } else {
              y.push(element.S3PermTds);
            }
          } else {
            if (stageStr == "1") {
              y.push(element.S1FeedPress);
            } else if (stageStr == "2") {
              y.push(element.S2FeedPress);
            } else {
              y.push(element.S3FeedPress);
            }
          }
        });
            const getStageLabel = (stageNumber: string | number) => {
  if (stageNumber == 1) return 'Stage 1';
  if (stageNumber == 2) return 'Stage 2';
  if (stageNumber == 3) return 'Stage 3';
  return ''; // default if not matched
};
           const stageLabel1 = getStageLabel(this.selectedStage);
        if (selectedwarranty.Type == 1) {
          this.graphName = `${this.plantName}/${this.trainDetails.Name}/Permeate Flow(m3/hr)<br/>${this.trainDetails.Systemconfig}`;
        } else {
          this.graphName = `${this.plantName}/${this.trainDetails.Name}/Feed Pressure(psi)<br/>${this.trainDetails.Systemconfig}`;
        }
        this.plot.plotLineWaranty("", "plot", x, y, selectedwarranty,stageLabel1);
      }
    });
  }
}
